window._define('modules/date-picker', ['jquery', 'bridge/widgets/calendarSelect'], function ($, CalendarSelect) {
    function getOptionsFromElementData(element) {
        var obj = $(element).data();

        return $.each($(element).data(), function (key, value) {
            var nkey = (key.match(/^option_(.*)/) || ['', key])[1];
            obj[nkey] = value;
            delete obj[key];
        });
    }

    // this options will parse data attributes to pass
    // datepicker options
    function createDatePickerFromElement(element) {
        var $element = $(element),
            options = getOptionsFromElementData(element);

        // targeting a div with 3 selects for day/month/year
        if ($('select', $element).length === 3) {
            new CalendarSelect(null, $element);
        } else {
            $element.datepicker(options);
        }
    }

    $(function () {
        $('.js-date-picker').each(function (n, element) {
            createDatePickerFromElement(element);
        });
    });
});
